import { formatRawDate } from "@app/util/formatters";

const getActivityDayKey = (dateString: null | string | undefined): string =>
  formatRawDate(dateString, "P", "_");

export default getActivityDayKey;
